import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { applyOrderItemTravellerCredit, getOrderItemV2 } from '~/services/BusinessTraveller/BusinessTravellerService';

export const orderItemV2QueryKeys = {
  all: ['orderItemV2'] as const,
  details: () => [...orderItemV2QueryKeys.all, 'detail'],
  detail: (orderItemId: string) => [...orderItemV2QueryKeys.details(), orderItemId],
};

interface UseGetOrderItemV2Params {
  orderItemId: string;
  enabled?: boolean;
}

export function useGetOrderItemV2({ orderItemId, enabled = true }: UseGetOrderItemV2Params) {
  return useQuery({
    queryKey: orderItemV2QueryKeys.detail(orderItemId),
    queryFn: async () => {
      const response = await getOrderItemV2(orderItemId);
      return response.result;
    },
    enabled: enabled && !!orderItemId,
  });
}

export function useApplyOrderItemTravellerCredit({ orderItemId }: { orderItemId: string }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (orderItemTravellerId: string) => {
      const response = await applyOrderItemTravellerCredit(orderItemTravellerId);
      return response.result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: orderItemV2QueryKeys.detail(orderItemId) });
    },
  });
}
